import {
  Button,
  ButtonSize,
  ButtonVariant,
  Intent,
  Shape,
} from '@axieinfinity/matcha'
import { ArrowSquareOutIcon } from '@axieinfinity/matcha-icons'
import clsx from 'clsx'

import { Ronin } from '~/components/Socials'
import bannerWallet from '~/public/images/banner-wallet.png'

import styles from './styles.module.scss'

export type TNoticeConnectWalletProps = {}

export const NoticeConnectWallet: React.FC<TNoticeConnectWalletProps> = () => {
  return (
    <div className={clsx(styles.noticeMFA, 'p-24 relative')}>
      <div className="flex flex-col gap-12 sm:w-2/3 relative z-10">
        <div className="text-h4">Link your Ronin wallet</div>
        <div className="text-body-m text-text-color-subdued">
          A secure storage solution for your digital assets and currencies.
          Built for your grandma too!
        </div>
      </div>

      <img
        className="absolute top-0 sm:right-24"
        src={bannerWallet}
        alt="banner-wallet"
      />

      <div className="flex flex-col sm:flex-row gap-12 mt-24">
        <Ronin />
        <Button
          size={ButtonSize.Small}
          shape={Shape.Default}
          intent={Intent.Primary}
          variant={ButtonVariant.Plain}
          text="Learn More"
          rightIcon={ArrowSquareOutIcon}
          onClick={async () =>
            window.open(
              'https://support.axieinfinity.com/hc/en-us/articles/4405346996251-How-to-Keep-Your-Account-Secure',
              '_blank',
            )
          }
        />
      </div>
    </div>
  )
}
